module.exports = __webpack_public_path__ + "img/cabinet_title.b01210eb.svg";